import React from "react";
import { Link } from "react-router-dom";

const NotFound = () => {
  return (
    <div style={styles.container}>
      <div style={styles.mainContent}>
        <div style={styles.relativeContainer}>
          <div style={styles.absoluteContainer}>
            <div style={styles.textContainer}>
              <h1 style={styles.heading}>
                Oops! We couldn't find what you were looking for. Maybe try
                searching for it? Or better yet, take a break and come back
                later.
              </h1>
              <p style={styles.subtext}>
                You may visit our homepage to get where you need to go.
              </p>
              <Link to="/">
                {" "}
                <button style={styles.button}>Take me there!</button>
              </Link>
            </div>
          </div>
          <div>
            <img
              src="https://i.ibb.co/G9DC8S0/404-2.png"
              alt="404"
              style={styles.image}
            />
          </div>
        </div>
      </div>
      <div>
        <img
          src="https://i.ibb.co/ck1SGFJ/Group.png"
          alt="Group"
          style={styles.sideImage}
        />
      </div>
    </div>
  );
};

const styles = {
  container: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100vh",
    overflow: "hidden",
  },
  mainContent: {
    paddingTop: "24px",
    paddingBottom: "24px",
    paddingLeft: "4px",
    paddingRight: "4px",
    marginTop: "24px",
    marginBottom: "24px",
    marginLeft: "44px",
    marginRight: "44px",
    display: "flex",
    flexDirection: "column-reverse",
    alignItems: "center",
    justifyContent: "center",
    gap: "16px",
    "@media (min-width: 640px)": {
      flexDirection: "row",
      gap: "28px",
    },
  },
  relativeContainer: {
    position: "relative",
  },
  absoluteContainer: {
    position: "absolute",
  },
  textContainer: {
    zIndex: "1",
    textAlign: "left",
    color: "#001f3f",
    width: "80%",
    height: "80%",
    overflow: "hidden",
    padding: "20px",
    boxSizing: "border-box",
  },
  heading: {
    fontSize: "1.2em",
    marginBottom: "10px",
    fontWeight: "bold",
  },
  subtext: {
    fontSize: "1em",
    marginBottom: "20px",
    color: "#333",
    fontFamily: "Helvetica , sans-serif", 
  },

  button: {
    padding: "12px 24px",
    fontSize: "1.2em",
    fontWeight: "bold",
    color: "#ffffff",
    backgroundColor: "#000099", 
    borderRadius: "5px",
    cursor: "pointer",
    border: "none", 
  },
  image: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
    zIndex: "0",
  },
  sideImage: {
    width: "100%",
  },
};

export default NotFound;
